import { NewsManager } from './newsManager.js';
import { UIManager } from './uiManager.js';
import './styles.css';

// Application initialization
class KondominioApp {
    constructor() {
        this.newsManager = null;
        this.uiManager = null;
    }

    init() {
        // Wait for DOM to be fully loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.startApp());
        } else {
            this.startApp();
        }
    }

    startApp() {
        try {
            // Initialize managers
            this.newsManager = new NewsManager();
            this.uiManager = new UIManager();

            // Initialize components
            this.newsManager.init();
            this.uiManager.init();

            console.log('Kondominio App initialized successfully');
        } catch (error) {
            console.error('Error initializing Kondominio App:', error);
        }
    }
}

// Create and initialize the application
const app = new KondominioApp();
app.init();

// Export for potential external use
export default app;
